import React, { useState, useEffect } from "react";
import instance from "../../api/api";
// import InputCreate from "../../features/InputCreate";
// import AddStock from "./feature/AddStock";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import { useNavigate } from "react-router-dom";
// import Button from "../../features/Button";
// import { FaArrowLeft } from "react-icons/fa";
import { useParams } from "react-router-dom";
import "./styleProduits.css";
// import { Upload } from "antd";

import { Header, LoadingSpinner, FormShared } from "../../shared/compoments";
let DATA_INFO_FORM_INPUT = [];
let DATA_INFO_FORM_SELECT = [];
let DATA_INFO_FORM_TEXT_AREA = [];
const statutColor = {
  Disponible: "green",
  Louer: "teal",
  Vendu: "red",
};

function EditBiens() {
  const { id } = useParams();

  const MySwal = withReactContent(Swal);

  const [dataBien, setDataBien] = useState({
    nom: "",
    cost: "",
    adresse: "",
    superficie: "",
    caution: "",
    description: "",
    municipality_id: "",
    category_id: "",
    nombre_pieces: "",
    nombre_portes: "",
    type_id: "",
    proprietaire_id: "",
  });
  const [fileList, setFileList] = useState([]);
  const [dataDetail, setDataDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);

  const onChangeForGalerie = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    const newTableau = convertirGalerie(newFileList);
    console.log("newTableau", newTableau);
  };
  const convertirGalerie = (tableauImage) => {
    let newTableau = [];
    tableauImage.forEach((item) => {
      newTableau.push(item.originFileObj);
    });
    return newTableau;
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  const RefreshProprieties = async () => {
    setIsLoading(true);
    try {
      const response = await instance.get(`proprieties/${id}`);
      const responseTypes = await instance.get("types");
      const responseMunicipalite = await instance.get("municipalite");
      const responseCategorie = await instance.get("categories");
      console.log(response);
      setDataDetail(response.data.data);
      const {
        nom,
        adresse,
        cost,
        superficie,
        caution,
        nombre_pieces,
        nombre_portes,
        municipality: { city_id },
        type: { category_id },
        type,
        description,
      } = response.data.data;
      getInfoFormSelect(
        responseMunicipalite?.data?.data,
        city_id,
        responseCategorie?.data?.data,
        category_id,
        responseTypes?.data?.data,
        type
      );
      getInfoFormTextArea(description);
      getInfoFormInput(
        nom,
        adresse,
        cost,
        superficie,
        caution,
        nombre_pieces,
        nombre_portes
      );
      setIsLoading(false);
    } catch (error) {
      console.error("Une erreur s'est produite : ", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getProduitDetail = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get(`proprieties/${id}`);
        const responseTypes = await instance.get("types");
        const responseMunicipalite = await instance.get("municipalite");
        const responseCategorie = await instance.get("categories");
        console.log(response.data.data);

        setDataDetail(response.data.data);

        const {
          nom,
          adresse,
          cost,
          superficie,
          caution,
          nombre_pieces,
          nombre_portes,
          municipality: { city_id },
          type: { category_id },
          type,
          description,
        } = response.data.data;
        getInfoFormSelect(
          responseMunicipalite?.data?.data,
          city_id,
          responseCategorie?.data?.data,
          category_id,
          responseTypes?.data?.data,
          type
        );
        getInfoFormTextArea(description);
        getInfoFormInput(
          nom,
          adresse,
          cost,
          superficie,
          caution,
          nombre_pieces,
          nombre_portes
        );
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };
    getProduitDetail();
  }, [id]);
  const deleteImageBiens = async (idPhoto) => {
    try {
      const response = await instance.delete(`photos/${idPhoto}`);
      console.log("response", response);
      if (response.data.status) {
        const index = dataDetail?.photos.findIndex(
          (item) => item.id === idPhoto
        );
        dataDetail?.photos.splice(index, 1);
        RefreshProprieties();
      }
    } catch (error) {
      console.error("Une erreur s'est produite : ", error);
    }
  };
  const updateProprieteProprietaire = async (e) => {
    e.preventDefault();
    setIsLoadingBtn(true);
    console.log("dataBien", dataBien);
    try {
      const formData = new FormData();
      const tableauImage = convertirGalerie(fileList);
      for (const element in tableauImage) {
        formData.append("path[]", tableauImage[element]);
      }
      formData.append("cost", dataBien.cost);
      formData.append("adresse", dataBien.adresse);
      formData.append("superficie", dataBien.superficie);
      formData.append("caution", dataBien.caution);
      formData.append("description", dataBien.description);
      // formData.append("municipality_id", dataBien.municipality_id);
      // formData.append("category_id", dataBien.category_id);
      formData.append("nombre_pieces", dataBien.nombre_pieces);
      formData.append("nombre_portes", dataBien.nombre_portes);
      // formData.append("type_id", dataBien.type_id);
      formData.append("proprietaire_id", dataBien.proprietaire_id);
      formData.append("nom", dataBien.nom);
      const response = await instance.post(`modifProprieties/${id}`, formData);

      console.log(response);
      if (response.data.status === false) {
        let msgError = [];
        for (const property in response.data.message) {
          msgError = [...msgError, response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoadingBtn(false);
      } else {
        RefreshProprieties();
        onChangeForGalerie({ fileList: [] });
        MySwal.fire({
          title: "Modification reussie.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });

        setIsLoadingBtn(false);
      }
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoadingBtn(false);
    }
  };
  const getInfoFormInput = (
    nom,
    adresse,
    cost,
    superficie,
    caution,
    nombre_pieces,
    nombre_portes
  ) => {
    DATA_INFO_FORM_INPUT = [
      {
        labelInput: "Bien",
        typeInput: "text",
        nameInput: "Bien",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        isDisabledInput:
          dataDetail && dataDetail.statut !== "Disponible" ? true : false,
        handleValue: (e) => {
          setDataBien({ ...dataBien, nom: e.target.value });
        },
        dataValue: nom,
      },
      {
        labelInput: "Adresse",
        typeInput: "text",
        nameInput: "lieu",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        isDisabledInput:
          dataDetail && dataDetail.statut !== "Disponible" ? true : false,
        handleValue: (e) => {
          setDataBien({ ...dataBien, adresse: e.target.value });
        },
        dataValue: adresse,
      },
      {
        labelInput: "Prix",
        typeInput: "number",
        nameInput: "Prix",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        isDisabledInput:
          dataDetail && dataDetail.statut !== "Disponible" ? true : false,
        handleValue: (e) => {
          setDataBien({ ...dataBien, cost: e.target.value });
        },
        dataValue: cost,
      },
      {
        labelInput: "Superficie",
        typeInput: "number",
        nameInput: "Superficie",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        isDisabledInput:
          dataDetail && dataDetail.statut !== "Disponible" ? true : false,
        handleValue: (e) => {
          setDataBien({ ...dataBien, superficie: e.target.value });
        },
        dataValue: superficie,
      },
      {
        labelInput: "Caution",
        typeInput: "number",
        nameInput: "Caution",
        isForModifyOrNotModify: true,
        isDisabledInput:
          dataDetail && dataDetail.statut !== "Disponible" ? true : false,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setDataBien({ ...dataBien, caution: e.target.value });
        },
        dataValue: caution,
      },
      {
        labelInput: "Nombre de pièces",
        typeInput: "number",
        nameInput: "Nombre de pièces",
        isForModifyOrNotModify: true,
        isDisabledInput:
          dataDetail && dataDetail.statut !== "Disponible" ? true : false,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setDataBien({ ...dataBien, nombre_pieces: e.target.value });
        },
        dataValue: nombre_pieces,
      },
      {
        labelInput: "Nombre de portes",
        typeInput: "number",
        nameInput: "Nombre de portes",
        isForModifyOrNotModify: true,
        isDisabledInput:
          dataDetail && dataDetail.statut !== "Disponible" ? true : false,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setDataBien({ ...dataBien, nombre_portes: e.target.value });
        },
        dataValue: nombre_portes,
      },
    ];
  };

  const getInfoFormSelect = (
    allMunicipalite,
    city_id,
    allCategorie,
    category_id,
    allTypes,
    type
  ) => {
    DATA_INFO_FORM_SELECT = [
      {
        labelHtmlFor: "commune",
        label: "Commune",
        selectName: "commune",
        selectId: "all_commune",
        selectDisabled: true,
        selectDefaultValue: city_id,
        handleChangeSelect: (e) => {
          setDataBien({ ...dataBien, municipality_id: e.target.value });
        },
        optionFirstSelected: "Sélectionner une commune",
        dataInfo: allMunicipalite,
      },
      {
        labelHtmlFor: "categories",
        label: "Catégorie",
        selectName: "categorie",
        selectId: "all_categorie",
        selectDisabled: true,
        selectDefaultValue: category_id,
        handleChangeSelect: (e) => {
          setDataBien({ ...dataBien, category_id: e.target.value });
        },
        optionFirstSelected: "Sélectionner une catégorie",
        dataInfo: allCategorie,
      },
      {
        labelHtmlFor: "types",
        label: "Type",
        selectName: "types",
        selectId: "all_Types",
        selectDisabled: true,
        selectDefaultValue: type.id,
        handleChangeSelect: (e) => {
          setDataBien({ ...dataBien, type_id: e.target.value });
        },
        optionFirstSelected: "Sélectionner un type",
        dataInfo: allTypes,
      },
    ];
  };

  const getInfoFormTextArea = (description) => {
    DATA_INFO_FORM_TEXT_AREA = [
      {
        labelHtmlFor: "description",
        label: "Description",
        textAreaDefaultValue: description,
        isDisabledTextArea:
          dataDetail && dataDetail && dataDetail.statut !== "Disponible"
            ? true
            : false,
        handleTextAreaChange: (e) => {
          setDataBien({ ...dataBien, description: e.target.value });
        },
      },
    ];
  };

  if (isLoading) return <LoadingSpinner />;
  return (
    <>
      {dataDetail && (
        <>
          <Header libelle={`Editer le bien : ${dataDetail.nom}`} isReturn />
          <div
            className="p-3"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}>
            <span
              className="badge"
              style={{ background: statutColor[dataDetail.statut] }}>
              {dataDetail.statut}
            </span>
          </div>
          <FormShared
            handleSubmit={updateProprieteProprietaire}
            btnTitle={"Modifier"}
            isLoading={isLoadingBtn}
            fileList={fileList}
            onChangeForGalerie={onChangeForGalerie}
            onPreview={onPreview}
            isUploadPhoto={
              dataDetail && dataDetail.statut !== "Disponible" ? false : true
            }
            dataInfoFormInput={DATA_INFO_FORM_INPUT}
            dataInfoFormSelect={DATA_INFO_FORM_SELECT}
            isTextarea
            dataTextArea={DATA_INFO_FORM_TEXT_AREA}
            isDataGalerie
            galeries={dataDetail?.photos}
            isDelete={
              dataDetail && dataDetail.statut !== "Disponible" ? false : true
            }
            deleteImageBiens={deleteImageBiens}
          />
        </>
      )}
    </>
  );
}

export default EditBiens;
